import axios from "axios";
import { getCookie } from "goi_common";

export const Axios = axios.create({
  withCredentials: true,
  baseURL: process.env.NEXT_PUBLIC_BASE_URL,
});

/**
 * 요청 직전에 access 토큰을 되살린다. 인증 여부로 동작이 갈리는 요청 앞에 붙인다.
 * access 쿠키는 httpOnly라 JS가 못 읽는다. 대신 같은 응답에서 같은 TTL(2h)로 심기는
 * `is_logged_in` 플래그 쿠키를 프록시로 쓴다. 플래그가 없으면 (a) 만료된 회원이거나
 * (b) 진짜 비회원인데, refresh 토큰은 읽을 수 없어 구분이 불가능하다. 그래서 일단
 * 시도하고 실패는 삼킨다 — (a)면 복구되고 (b)면 400을 받고 그대로 비회원으로 진행한다.
 *
 * 앱 상태(recoil 등) 동기화는 하지 않는다. 여기는 React 밖이고, parlor처럼 전역 로그인
 * 상태가 없는 앱에서도 그대로 쓰여야 한다. 되살렸는지만 알려주고 판단은 부르는 쪽이 한다.
 *
 * @returns refresh로 세션을 되살렸으면 `true`. 이미 유효했거나 되살리지 못했으면 `false`.
 */
export const ensureFreshAuth = async (): Promise<boolean> => {
  const isLoggedInCookieKey = process.env.NEXT_PUBLIC_IS_LOGGED_IN_COOKIE;
  if (!isLoggedInCookieKey || getCookie(isLoggedInCookieKey) === "true") return false;

  try {
    await Axios.post("/users/refresh/");
    return true;
  } catch {
    return false;
  }
};

Axios.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalRequest = err.config;

    if (
      err.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("/users/refresh/")
    ) {
      originalRequest._retry = true;
      try {
        await Axios.post("/users/refresh/");
        return Axios(originalRequest);
      } catch {}
    }

    return Promise.reject(err);
  },
);
